<template>
  <b-modal :show="show" title="Booking Charges" @hide="close" @hidden="close" hide-footer>
    <b-row>
      <b-col>
        <b-form-group label="Select Booking">
          <b-form-select v-model="selectedBooking" :options="bookingOptions" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-table :items="charges" :fields="fields" striped hover responsive>
      <template #cell(total_amount)="data">
        <strong>${{ parseFloat(data.item.total_amount).toFixed(2) }}</strong>
      </template>
    </b-table>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="downloadInvoice">Download Invoice</b-button>
    </div>
  </b-modal>
</template>

<script>
import { request } from "@/Util/Request";

export default {
  name: "BookingChargesModal",
  props: {
    show: Boolean,
  },
  data() {
    return {
      charges: [],
      selectedBooking: "",
      bookingOptions: [],
      fields: [
        { key: "item_name", label: "Item" },
        { key: "description", label: "Description" },
        { key: "quantity", label: "Qty" },
        { key: "amount", label: "Unit Price" },
        { key: "total_amount", label: "Total" },
        { key: "charged_at", label: "Date" },
      ],
    };
  },
  watch: {
    selectedBooking(newVal) {
      this.fetchBookingCharges(newVal);
    },
  },
  async created() {
    await this.fetchBookings();
  },
  methods: {
    async fetchBookings() {
      try {
        const response = await request({
          method: "get",
          url: "/billing/active-bookings",
        });
        this.bookingOptions = response.data.map((booking) => ({
          value: booking.id,
          text: `${booking.user.full_name} (${booking.check_in} to ${booking.check_out})`,
        }));
        if (this.bookingOptions.length) {
          this.selectedBooking = this.bookingOptions[0].value;
        }
      } catch (error) {
        console.error("Error fetching bookings:", error);
        this.$toast.error("Failed to load active bookings");
      }
    },

    async fetchBookingCharges(bookingId) {
      try {
        const response = await request({
          method: "get",
          url: `/bookings/${bookingId}/charges`,
        });
        this.charges = response.data.charges;
      } catch (error) {
        console.error("Error fetching booking charges:", error);
        this.$toast.error("Failed to load booking charges");
      }
    },

    async downloadInvoice() {
      if (!this.selectedBooking) {
        this.$toast.error("Please select a booking first");
        return;
      }
      
      try {
        const response = await request({
          method: "get",
          url: `/bookings/${this.selectedBooking}/checkout-bill`,
          responseType: "blob",
        });
        
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `checkout-bill-${this.selectedBooking}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        this.$toast.success("Invoice downloaded successfully");
      } catch (error) {
        console.error("Error downloading invoice:", error);
        this.$toast.error("Failed to download invoice");
      }
    },

    close() {
      this.$emit("close");
      this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped></style>

